import { Container as ChakraContainer, ContainerProps } from '@chakra-ui/react';
import { FC } from 'react';

export const Container: FC<ContainerProps> = ({ children, ...props }) => (
  <ChakraContainer {...props} maxWidth="1475px">
    {children}
  </ChakraContainer>
);
